var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('CustomerDeliveryStatusesComponent')],1)],1),_c('v-row',[_c('v-col',[_c('CustomerSupportTicketStatusesComponent')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }